export const CustomerPayment = [
	{ id: 0, label: "cb", short: "CB", long: "Carte Bleue" },
	{ id: 1, label: "esp", short: "ESP", long: "Espèce" },
	{ id: 2, label: "tr", short: "TR", long: "Ticket resto" },
	{ id: 3, label: "chq", short: "CHQ", long: "Chèque" }
]
export const CustomerCity = ["Berck", "Rang-du-Fliers", "Verton", "Grofflier"]

export default CustomerCity
